
import React from 'react';
import { FadeIn } from '@/components/Animations';

interface DashboardHeaderProps {
  title: string;
  description: string;
  showBackButton?: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  title, 
  description 
}) => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl md:text-3xl font-display font-semibold mb-2 text-hormony-charcoal">
        {title}
      </h1>
      <p className="text-hormony-charcoal/70 text-sm md:text-base">
        {description}
      </p>
    </div>
  );
};
